import { render, staticRenderFns } from "./e-link-entity-page.vue?vue&type=template&id=1da966a0&scoped=true&lang=pug"
import script from "./e-link-entity-page.vue?vue&type=script&lang=js"
export * from "./e-link-entity-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da966a0",
  null
  
)

export default component.exports